import { history } from '../App'
import { ROUTES } from '../App.routes'

export const isCurrentLocationOnRegisterPage = () => {
  const location = history.location

  return location.pathname.startsWith(ROUTES.REGISTER)
}
